<template>
  <div class="inner-dashboard">
    <PropertyDashboardSidebarNav :propertyId="propertyId" />
    <div class="inner-dashboard-content container campaign-container">
      <div class="campaign-header">
        <PropertyDashboardContentHeading
          :propertyId="propertyId"
          :showUploadContentButton="false"
        />
      </div>
      <div class="campaign-content">
        <div class="position-relative">
          <loading
            v-model:active="isLoading"
            :is-full-page="false"
            loader="dots"
            :opacity="1"
            class="mx-auto p-0 m-0 loading-container"
          />
          <div class="contacts-table">
            <DatatableComponent
              :columns="columns"
              v-if="!isLoading"
              :data="contacts_identified"
              :options="{
                paging: false,
                ordering: true,
                searching: false,
                info: false,
                responsive: true,
              }"
              :keys="keys"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal id="contacstModal" class="edit-modal">
    <template v-slot:title>Edit Contact</template>
    <template v-slot:body>
      <form @submit.prevent="editContact" v-if="activeContact">
        <Input v-model="activeContact.name" type="text" label="Name" />
        <label for="logo" class="form-label">Logo Image</label>
        <input
          class="form-control"
          v-on:change="onFileChange"
          type="file"
          id="logo"
        />
        <img :src="logoUrl" class="contact-logo" v-if="logoUrl" />
        <Input v-model="activeContact.jobTitle" type="text" label="Job Title" />
        <Input v-model="activeContact.company" type="text" label="Company" />
        <Input v-model="activeContact.location" type="text" label="Location" />
        <Input v-model="activeContact.website" type="text" label="Website" />
        <Input v-model="activeContact.phone" type="text" label="Phone" />
        <Input v-model="activeContact.email" type="text" label="Email" />
        <Input
          v-model="activeContact.linkedIn"
          type="text"
          label="LinkedIn URL"
        />
        <label for="hide_status" class="form-label me-2"
          >Show this contact?
        </label>
        <input
          id="hide_status"
          class="type__input"
          type="checkbox"
          name="type"
          :value="true"
          v-model="isContactVisible"
        />
        <button type="submit" class="btn btn-primary wti-btn-black">
          <span
            v-if="submitting"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          {{ submitting ? "" : "Submit" }}
        </button>
      </form>
    </template>
  </Modal>
</template>

<style lang="sass" scoped>
@use "@/assets/vars.sass" as *
@use 'datatables.net-bs5' as *

.contacts-table
  min-height: 30vh
  overflow-y: auto
  .datatable
    width: 99%
    thead
      th
        white-space: nowrap
    tbody
      td
        white-space: nowrap
.contact-logo
  width: 95px
  height: 95px
  border-radius: 50%
  margin-bottom: 19px
  object-fit: cover
</style>


<script>
import { ref } from "vue";
import api from "@/services/BackendConnection";
import PropertyDashboardSidebarNav from "@/components/PropertyDashboardSidebarNav.vue";
import PropertyDashboardContentHeading from "@/components/PropertyDashboardContentHeading.vue";
import DatatableComponent from "@/components/DatatableComponent.vue";
import Modal from "@/components/Modal.vue";
import Input from "@/components/Input.vue";
import $ from "jquery";
import mockData from "@/utils/mockData.json";

export default {
  name: "PropertyReporting",
  setup(props) {
    return {
      keys: [
        "Name",
        "Logo",
        "Job Title",
        "Company",
        "Location",
        "Website",
        "Phone",
        "Email",
        "LinkedIn",
        "Hide/Show",
        "Edit",
        "Send Lead Email",
      ],
      isLoading: ref(true),
      submitting: ref(false),
      contacts_identified: ref([]),
      allContacts: mockData.identifiedContacts,
      activeContact: ref(null),
      logoUrl: ref(null),
      submitting: ref(false),
    };
  },
  data() {
    var self = this;
    return {
      columns: [
        {
          data: "name",
          className: "align-middle",
          defaultContent: "",
        },
        {
          data: "logo",
          className: "align-middle",
          orderable: false,
          render: function (data, type, row, meta) {
            if (data) {
              var style =
                "height:50px; width:50px; margin: 0 0 0 0; border-radius: 50%;";
              return '<img src="' + data + '" style="' + style + '" />';
            } else {
              return "";
            }
          },
        },
        {
          data: "jobTitle",
          className: "text-break align-middle",
          defaultContent: "",
        },
        {
          data: "company",
          className: "text-break align-middle",
          defaultContent: "",
        },
        {
          data: "location",
          className: "align-middle",
          defaultContent: "",
        },
        {
          data: "website",
          className: "text-break align-middle",
          defaultContent: "",
        },
        // {
        //   data: "website",
        //   className: "text-center align-middle",
        //   orderable: false,
        //   render: function (data, type, row, meta) {
        //     var url = new URL(`../assets/world-wide-web.png`, import.meta.url)
        //       .href;
        //     return (
        //       '<a href="' +
        //       data +
        //       '" target="_blank" style="background-color:rgba(10, 102, 194, 0.1); padding: 9px; border-radius: 8px; display: inline-block;"><span class="d-flex align-items-center"> <img src="' +
        //       url +
        //       '" style="height:20px; width:20px;" /></span></a>'
        //     );
        //   },
        // },
        {
          data: "phone",
          className: "align-middle",
          defaultContent: "",
        },
        {
          data: "email",
          className: "text-break align-middle",
          defaultContent: "",
        },
        {
          data: "linkedIn",
          className: "text-break align-middle",
          defaultContent: "",
        },
        {
          data: "hide",
          defaultContent: "-",
          className: "text-center align-middle",
          render: function (data, type, row) {
            if (type === "display") {
              var html = "";
              // $(document).on("click", ".show-contact-" + row._id, function () {
              //   self.showContact(row);
              // });
              // $(document).on("click", ".hide-contact-" + row._id, function () {
              //   self.hideContact(row);
              // });
              if (data) {
                html =
                  '<button class="btn btn-danger show-contact-' +
                  row._id +
                  '" >' +
                  '<img src="' +
                  self.getImgUrl("eye_slash.png") +
                  '" style="height:12px;"/></button>';
              } else {
                html =
                  '<button class="btn btn-success hide-contact-' +
                  row._id +
                  '" >' +
                  '<img src="' +
                  self.getImgUrl("eye.png") +
                  '" style="height:12px;"/></button>';
              }
              return html;
            }
          },
        },
        {
          data: null,
          defaultContent: "-",
          orderable: false,
          className: "text-center align-middle",
          render: function (data, type, row) {
            if (type === "display") {
              $(document).on("click", ".contacstModal-" + row._id, function () {
                self.updateActiveate(row);
              });
            }
            var html =
              '<div class="d-flex">' +
              '<a class="btn btn-success contacstModal-' +
              row._id +
              '" id="' +
              row._id +
              '_edit_contacts" data-bs-toggle="modal" data-bs-target="#contacstModal" style="color:white;">Edit</a>' +
              "</div>";
            return html;
          },
        },
        {
          data: "hide",
          defaultContent: "-",
          orderable: false,
          className: "text-center align-middle",
          render: function (data, type, row) {
            if (type === "display") {
              if (!data) {
                $(document).on("click", ".send-email-" + row._id, function () {
                  this.disabled = true;
                  self.sendNewLeadEmail(row);
                });

                var html = (html =
                  '<button class="btn btn-primary send-email-' +
                  row._id +
                  '" >' +
                  '<img src="' +
                  self.getImgUrl("envelope.svg") +
                  '" style="height:12px;"/></button>');
                return html;
              }
            }
          },
        },
      ],
    };
  },
  props: ["propertyId"],
  components: {
    Modal,
    PropertyDashboardSidebarNav,
    PropertyDashboardContentHeading,
    DatatableComponent,
    Input,
  },
  computed: {
    isContactVisible: {
      get() {
        return !this.activeContact.hide;
      },
      set(value) {
        this.activeContact.hide = !value;
      },
    },
  },
  methods: {
    updateActiveate(row) {
      this.activeContact = row;
      this.activeContact.show = !row.hide;
      this.logoUrl = row.logo;
    },
    async getAllContacts() {
      this.isLoading = true;
      var info = {
        propertyId: this.propertyId,
        allContacts: true,
      };
      let res = await api().getMAContacts(info);
      this.isLoading = false;
      if (res.data) {
        this.contacts_identified = res.data;
      }
    },
    // showContact(item) {
    //   this.isLoading = true;
    //   var id = item._id;
    //   var info = {
    //     id: id,
    //     hide: false,
    //     propertyId: this.propertyId,
    //   };
    //   api()
    //     .updateContact(info)
    //     .then((res) => {
    //       this.isLoading = false;
    //       if (res.data) {
    //         this.contacts_identified = res.data;
    //       }
    //     });
    // },
    // hideContact(item) {
    //   this.isLoading = true;
    //   var id = item._id;
    //   var info = {
    //     id: id,
    //     hide: true,
    //     propertyId: this.propertyId,
    //   };

    //   api()
    //     .updateContact(info)
    //     .then((res) => {
    //       this.isLoading = false;
    //       if (res.data) {
    //         this.contacts_identified = res.data;
    //       }
    //     });
    // },
    editContact(e) {
      e.preventDefault();
      this.isLoading = true;
      this.submitting = true;
      var info = {
        propertyId: this.propertyId,
      };

      info = { ...info, ...this.activeContact };
      const formData = new FormData();
      Object.keys(info).forEach((key) => {
        formData.append(key, info[key]);
      });

      api()
        .updateContactDetails(formData)
        .then((res) => {
          this.submitting = false;
          var myModal = document.getElementById("contacstModalclose");
          myModal.click();
          this.isLoading = false;
          if (res.data) {
            this.contacts_identified = res.data;
          }
        });
    },
    sendNewLeadEmail(row) {
      this.isLoading = true;
      var id = row._id;
      var info = {
        id: id,
        propertyId: this.propertyId,
      };
      api()
        .sendNewLeadEmail(info)
        .then((res) => {
          this.isLoading = false;
          if (res.data?.success) {
            alert("Emails sent successfully");
          } else {
            alert("Emails sending failed");
          }
        });
    },
    getImgUrl(fileName) {
      return new URL(`../assets/${fileName}`, import.meta.url).href;
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.activeContact.logo = files[0];
      this.logoUrl = URL.createObjectURL(files[0]);
    },
  },
  async mounted() {
    await this.getAllContacts();
  },
};
</script>
